import VueLib from 'vue'
import merge from 'lodash.mergewith'
import * as Sentry from '@sentry/browser'
import { CaptureConsole, Dedupe, ExtraErrorData, ReportingObserver, RewriteFrames, Vue } from '@sentry/integrations'

import { Integrations as TracingIntegrations } from '@sentry/tracing'

export default function (ctx, inject) {
  /* eslint-disable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
  const config = {
    dsn:"https:\u002F\u002Fc44e5253510446f2bf43403bfb8baab6@o93004.ingest.sentry.io\u002F5194385",
    environment:"production",
    release:"4e7702b22",
    maxBreadcrumbs:15,
    normalizeDepth:5,
    tracesSampleRate:0.05
  }

  const runtimeConfigKey = "sentry"
  if (ctx.$config && runtimeConfigKey && ctx.$config[runtimeConfigKey]) {
    merge(config, ctx.$config[runtimeConfigKey].config, ctx.$config[runtimeConfigKey].clientConfig)
  }

  config.integrations = [
    new Dedupe(),
    new ExtraErrorData(),
    new ReportingObserver(),
    new RewriteFrames(),
    new Vue({ Vue: VueLib, ...{"attachProps":true,"logErrors":false,"tracing":true,"tracingOptions":{"hooks":["create","mount","update","destroy"],"timeout":5000,"trackComponents":true,"attachProps":true,"logErrors":true}}}),
    new CaptureConsole({levels:["error"]})
  ]

    config.integrations.push(new TracingIntegrations.BrowserTracing({"startTransactionOnLocationChange":true,"startTransactionOnPageLoad":true}))

  /* eslint-enable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
  Sentry.init(config)

  inject('sentry', Sentry)
  ctx.$sentry = Sentry
}
